import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { RightSideSection } from './StyledComponents';
import Text from '../../../shared/Text/Text';
import PrizeComponent from '../../../shared/PrizeComponent/PrizeComponent.jsx';

const TextContainer = styled.div`
  font-family: 'Montserrat';
  margin: 12px 23px 0px;
`;

const BodyTab = styled.div`
  flex-direction: column;
  background-color: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px 8px 8px 8px;
  margin-top: -1px;
  display: flex;
  min-height: 555px;
`;

const Container = styled.div`
  background-color: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px 8px 8px 8px;
  margin: 12px 24px 24px;
  flex: 1;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-top: 24px;
  padding-bottom: 24px;
`;

const UserPreview = ({ raffle }) => {
  const { t } = useTranslation('prizes');

  return (
    <RightSideSection>
      <BodyTab>
        <TextContainer>
          <Text as="span" variant="h6" color={'black.100'}>
            {t('userPreview.title')}
          </Text>
        </TextContainer>
        <Container>
          <PrizeComponent raffle={raffle} ticketsCount={0} />
        </Container>
      </BodyTab>
    </RightSideSection>
  );
};

export default UserPreview;
